import { first } from 'lodash';

import ArticleItemList from './helpers/ArticleItemList';
import handleExternalUrl from './helpers/handle_external_url';
import pathToContent from './helpers/path_to_content';
import placeholder_url from '../../../../placeholder';
import { makeT } from '../../../location/locales';

const mapItemFromData = content => {
  if (!content) {
    return null;
  }
  const { metadata } = content || {};
  const { settings } = ({} = metadata);
  const { settings: { details = {} } = {} } = metadata || {};
  const t = makeT(Board.build.language);
  const availability = settings?.availability;
  const contentUrl = availability?.status === 'external' ? handleExternalUrl(availability?.externalUrl) : pathToContent(content);

  return {
    metadata,
    image: details?.image?.file
      ? details.image
      : { file: placeholder_url(370, 185) },
    img: details?.image?.file || placeholder_url(370, 185),
    alt: details?.image?.alt,
    prehead: [
      details?.taxonomies?.primary_category ||
      first(details?.taxonomies?.categories),
    ]
      .filter(x => x)
      .join(' • '),
    heading: details?.information?.title,
    text: details?.information?.description,
    linkText: t('builder.data.read_more'),
    url: contentUrl,
    icon: 'newspaper-o',
  };
};

export default ArticleItemList({
  search: {
    name: 'Fleetwood Blog Articles',
    type: 'Article::Fleetwood',
    preview: result => ({
      preheading: result.category,
      heading: result.proper_name,
    }),
  },
  list: {
    availableIn: ['www.fleetwoodusa.com'],
    name: 'Blog - Fleetwood',
    attributeSet: {
      name: 'Article Attributes',
      path: 'blog',
    },
    dataset: 'fleetwood_blog',
    itemListMap: mapItemFromData,
    cardSetMap: mapItemFromData,
    categoryFeaturesMap: mapItemFromData,
    enableSearch: true,
  },
});
